// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2475":"2867c268aca3979e","3557":"64c7de0248728406","3706":"f6b7ada176a8d384","5681":"cf62c00c92ba471f"}[chunkId] + ".js";
};